// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

// Query String
const queryString = require("querystring")

class productAPI extends MainAPI {
	/**
	 * @return {object} product list
	 * @param {*} productDetails - Contains pagination data
	 * @param productId
	 */
	async getProducts(petId, productDetails) {
		return API.get(`${ENDPOINTS.GET_BUNDLES}/${petId}?${queryString.stringify(productDetails)}`)
	}

	async getPublicProducts(queryParams) {
		return API.get(`${ENDPOINTS.GET_BUNDLES_PUBLIC_LIST}?${queryString.stringify(queryParams)}`)
	}

	async getPublicCategoryProducts(queryParams) {
		return API.get(`${ENDPOINTS.GET_BUNDLES_PUBLIC_LIST_PRODUCTS}?${queryString.stringify(queryParams)}`)
	}

	async getPublicProductDetails(bundleId) {
		return API.get(`${ENDPOINTS.GET_BUNDLES_PUBLIC_DETAILS}?f_bundleId=${bundleId}`)
	}

	/**
	 * @return {object} product details
	 * @param {*} productId - product id
	 */
	async getProductById(productId) {
		return API.get(`${ENDPOINTS.GET_PRODUCT}/${productId}`)
	}

	/**
	 *
	 * @param {Integer} productId
	 * @returns
	 */
	async getProductsDogDetails(productId) {
		return API.get(`${ENDPOINTS.GET_PRODUCT}/${productId}/dog-details`)
	}

	/**
	 * @return {object} product types
	 */
	async getProductTypes() {
		return API.get(`${ENDPOINTS.GET_PRODUCT_TYPE}`)
	}

	/**
	 * @return {object} bundles list - lowest price by product type
	 * @param {* }petId - active pet id
	 */
	async getBundlesLowestPrice(petId) {
		return API.get(`${ENDPOINTS.GET_BUNDLES}/${petId}/lowest-price`)
	}

	/**
	 * @return {object} bundle list
	 * @param {*} bundleDetails - Contains pagination data
	 *
	 */
	async getBundles(bundleDetails) {
		return API.get(`${ENDPOINTS.GET_BUNDLES}?${queryString.stringify(bundleDetails)}`)
	}

	/**
	 * @return {object} bundle list
	 * @param {*} bundleDetails - Contains pagination data
	 *
	 */
	async getPetOrderBundles(bundleDetails) {
		return API.get(`${ENDPOINTS.GET_PET_ORDER}${ENDPOINTS.GET_BUNDLES}?${queryString.stringify(bundleDetails)}`)
	}

	/**
	 * @return {object} bundle list
	 * @param {*} bundleDetails - Contains pagination data
	 *
	 */
	async getPetOrder(orderId) {
		return API.get(`${ENDPOINTS.GET_PET_ORDER}/${orderId}/orders`)
	}

	/**
	 * @return {object} bundle details
	 * @param {*} bundleDetails - Contains product details
	 *
	 */
	async getBundleById(bundleId, petId) {
		const petDetail = { petId }
		return API.get(`${ENDPOINTS.GET_BUNDLE}/${bundleId}`, petDetail)
	}
}

export default new productAPI()
